exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mb-header[data-v-586e4f71]{width:100%;height:2.75rem;display:flex;align-items:center;justify-content:space-between;padding:0 .88rem;background:#fff;position:relative;position:sticky;top:0;z-index:10}.mb-header .mb-left[data-v-586e4f71]{font-size:1rem;font-weight:400;color:#666}.mb-header .mb-title-wrap[data-v-586e4f71]{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%)}.mb-header .mb-title[data-v-586e4f71]{font-size:1.13rem;font-weight:500;color:#333;letter-spacing:.03rem}.mb-header .mb-back[data-v-586e4f71]{width:.5rem;height:.81rem}", ""]);

// exports
